import React from "react";
import TextField from "@mui/material/TextField";
import "./style.css";

const InfoInput = ({ value, onChange, error, name, type, placeholder, required }) => {
  return (
    <div className="premium-input-wrapper mb-3">
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="premium-field"
        style={{
          width: "100%",
          padding: "12px 16px",
          borderRadius: "12px",
          border: "1px solid rgba(0,0,0,0.05)",
          background: "rgba(241, 245, 249, 0.4)",
          fontSize: "0.95rem",
          fontWeight: "500",
          transition: "all 0.3s ease",
          outline: 'none'
        }}
        onFocus={(e) => {
          e.target.style.background = "white";
          e.target.style.borderColor = "var(--primary-color)";
          e.target.style.boxShadow = "0 4px 12px rgba(79, 70, 229, 0.08)";
        }}
        onBlur={(e) => {
          e.target.style.background = "rgba(241, 245, 249, 0.4)";
          e.target.style.borderColor = "rgba(0,0,0,0.05)";
          e.target.style.boxShadow = "none";
        }}
      />
      {error && <p className="text-danger small mt-1">{error}</p>}
      <style>
        {`
          .premium-field::placeholder { color: var(--text-light); opacity: 0.7; }
          .premium-field:hover { background: rgba(241, 245, 249, 0.6); }
        `}
      </style>
    </div>
  );
};

export default InfoInput;
